const PaymentGateway = {
  PAYPAL: 'paypal',
  BAYARIND: 'bayarind'
}

export default PaymentGateway
